import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private httpClient: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string,  @Inject('fileServerUrl') private fileServerUrl: string,) { }
  getAllUsers(params) {
    return this.httpClient.post(this.apiEndPoint + '/users/_search?size=1000', params);
  }
  getAllProfiles() {
    let params = {
      "query": {},
      sort: [{ "_kuzzle_info.createdAt": "asc" }]
    }
    return this.httpClient.post(this.apiEndPoint + '/profiles/_search?size=1000', params);

  }
  getAllRoles() {
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/configparam/_search?size=1000');

  }
  getUserDevices(user) {
    const filter = {"query":{"bool":{"must":[
      {"query_string":{ "query":`${user}_devices`, "type": "phrase", "fields": ["_id"] } }
    ]}},"sort":{"_kuzzle_info.createdAt":"desc"}}
    return this.httpClient.post(`${this.apiEndPoint}/gwdevice/configparam/_search?size=1`, filter);
  }
  createUser(body, userName) {
    return this.httpClient.post(this.apiEndPoint + '/users/' + userName + '/_create', body);

  }
  createUserByAdmin(body, userName) {
    return this.httpClient.post(this.fileServerUrl + '/users/_create', body);

  }
  updateUser(body, userName) {
    return this.httpClient.put(this.apiEndPoint + '/users/' + userName + '/_update', body);

  }
  deleteUser(userName) {
    return this.httpClient.delete(this.apiEndPoint + '/users/' + userName);

  }
  updatePassword(password: any) {
    let body = {
      "password": password
    }
   
    return this.httpClient.put(this.fileServerUrl + '/_me/credentials/_update', body);

  }

  getStrategyOfUser(id){
    return this.httpClient.get(this.apiEndPoint + '/users/'+id+'/_strategies');
  }
updateUserPassw0rdByAdmin(id,password){
  let body = {
    "username": id,
    "password": password
  }
  return this.httpClient.put(this.fileServerUrl+ '/credentials/_update',body)
}

  getCurrentUser() {
        return this.httpClient.get(`${this.apiEndPoint}/_me`)
    }

  addDevices(devices: any, user) {
    console.log(JSON.stringify(devices));
    const filter = {"query":{"bool":{"must":[
      {"query_string":{ "query":`${user}_devices`, "type": "phrase", "fields": ["_id"] } }
    ]}},"sort":{"_kuzzle_info.createdAt":"desc"}}
    return this.httpClient.post(`${this.apiEndPoint}/gwdevice/configparam/_search?size=1`, filter).pipe(
      switchMap((res: any) => {
        const hits = res?.result?.hits || [];
        const updatedData = {devicesList: devices};
        return hits.length === 0
          ? this.httpClient.post(`${this.apiEndPoint}/gwdevice/configparam/_create?_id=${user}_devices`, updatedData)
          : this.httpClient.patch(`${this.apiEndPoint}/gwdevice/configparam/${user}_devices/_update`, updatedData);
      })
    );
  }

}



